var map = {
	"./avatar.png": 621,
	"./christmas/cara-de-papa-noel.png": 9048,
	"./christmas/reno.png": 1326,
	"./client_1.png": 9775,
	"./client_2.png": 3566,
	"./client_3.png": 3565,
	"./client_4.png": 910,
	"./colombia/chiva.png": 6282,
	"./colombia/colombia.png": 7624,
	"./colombia/cumbia.png": 3110,
	"./educacion/cognos.jpg": 4484,
	"./educacion/edteam.png": 3600,
	"./educacion/iti.png": 9160,
	"./educacion/mintic.png": 1060,
	"./educacion/platzi.png": 5854,
	"./educacion/sena.png": 3430,
	"./educacion/udec.png": 6513,
	"./educacion/udemy.png": 4748,
	"./hallowen/calabaza.png": 767,
	"./hallowen/fantasma.png": 5754,
	"./trabajo/avisoft.png": 1340,
	"./trabajo/manases.png": 7255,
	"./trabajo/sena.png": 2082,
	"./trabajo/start.png": 3723,
	"./trabajo/udec.png": 9009,
	"./trabajos/logo_work1.svg": 5376,
	"./trabajos/logo_work10.png": 3489,
	"./trabajos/logo_work11.jpg": 4710,
	"./trabajos/logo_work12.png": 2653,
	"./trabajos/logo_work13.jpg": 5463,
	"./trabajos/logo_work13.png": 3326,
	"./trabajos/logo_work14.jpg": 1304,
	"./trabajos/logo_work15.png": 9910,
	"./trabajos/logo_work16.jpg": 6847,
	"./trabajos/logo_work2.png": 8185,
	"./trabajos/logo_work3.png": 9341,
	"./trabajos/logo_work4.png": 101,
	"./trabajos/logo_work5.png": 9039,
	"./trabajos/logo_work6.png": 2662,
	"./trabajos/logo_work7.png": 9990,
	"./trabajos/logo_work8.png": 7885,
	"./trabajos/logo_work9.png": 1759,
	"./trabajos/work1.png": 8539,
	"./trabajos/work10.jpg": 4041,
	"./trabajos/work11.jpg": 2429,
	"./trabajos/work12.jpg": 5094,
	"./trabajos/work13.png": 5309,
	"./trabajos/work14.png": 4506,
	"./trabajos/work15.png": 9138,
	"./trabajos/work16.jpg": 1111,
	"./trabajos/work17.jpg": 7291,
	"./trabajos/work2.png": 1760,
	"./trabajos/work3.jpg": 4098,
	"./trabajos/work4.jpg": 5657,
	"./trabajos/work5.png": 6751,
	"./trabajos/work6.jpg": 7588,
	"./trabajos/work7.png": 5089,
	"./trabajos/work8.jpg": 691,
	"./trabajos/work9.jpg": 8567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 252;